export const MOUNTED = 'MOUNTED';
export const CLICK = 'CLICK';
export const VISIBLE = 'VISIBLE';
export const INVISIBLE = 'INVISIBLE';
export const EXPAND_FILE = 'EXPAND_FILE';
export const COLLAPSE_FILE = 'COLLAPSE_FILE';
export const COLLAPSE_FILE_BY_USER = 'COLLAPSE_FILE_BY_USER';
export const EXPANDED_LINES = 'EXPANDED_LINES';
export const HIGHLIGHT_LINES = 'HIGHLIGHT_LINES';
export const CLEAR_HIGHLIGHT = 'CLEAR_HIGHLIGHT';
